export default "assets/images/flags/de-d07e94b6.svg";